import React from 'react';
import { Link } from 'react-router-dom';

import styles from './SidePanel.module.scss';

interface Props {
  label: string;
  href: string;
  selected: boolean;
}

const SidePanelItem = ({ label, href, selected }: Props) => (
  <Link to={href}>
    <div
      className={`${styles.side_panel__tab} ${
        selected ? styles.side_panel__tab__selected : ''
      }`}
    >
      {label}
    </div>
  </Link>
);

export default SidePanelItem;
